import Lottie from 'lottie-react';

import lottieDiagnoses from '../jsons/diagnoses.json';

const LottieDiagnoses = props => {
  return <Lottie animationData={lottieDiagnoses} loop={false} {...props} />;
};

export default LottieDiagnoses;
